import { Component } from "react";
import CenterBox from "../../components/CenterBox";

import Warning from "../../assets/icons/warning.svg";

import "../../assets/icons/material-ui-icon.css";

class RoomNotFound extends Component {
    render() {
        const { errorMessage, game } = this.props;

        // Use custom error message if provided, otherwise default message
        const message = errorMessage || `Room with code ${game?.roomCode || 'unknown'} was not found!`;

        return (
            <CenterBox logo cancel="Return to menu" {...this.props}>
                <img src={Warning} className="material-ui-icon" style={{ fontSize: "4.5em" }} alt="Warning" />
                <div className="message-box">
                    {message}
                </div>
            </CenterBox>
        );
    }
}

export default RoomNotFound;
